export { default as ProductsCollectionsFilterBadge } from './ProductsCollectionsFilterBadge';
